// extracted by mini-css-extract-plugin
export default {"page":"style_page__UPlJX","page__loading":"style_page__loading__76lt2"};